export default "__VITE_ASSET__04aoDKxL__"